export class SelectOther {
    $select: JQuery;
    key: string;
    showCallback: Function;
    hideCallback: Function;

    public constructor(options: SelectOtherOptions) {
        this.$select = options.select;
        this.showCallback = options.showCallback;
        this.hideCallback = options.hideCallback;

        this.key = options.key !== undefined ? options.key : "other";

        this.bindEvents();

        this.$select.trigger("change");
    }

    private bindEvents() {
        this.$select.on("change", (e) => {
            const selected = $(e.target).find(':selected');
            let found = false;

            selected.each((_index, element) => {
                if($(element).val() === this.key)
                    found = true;
            });
            
            found ? this.showCallback() : this.hideCallback();
        });
    }
}

interface SelectOtherOptions {
    select: JQuery;
    showCallback: Function;
    hideCallback: Function;
    key? : string;
}